import { useState, useEffect } from "react"
import { Effect } from "../../types";
import { OptionalNumber } from "../../types/optional";
import { optionalNumber } from "..";
type WindowSize = {
    width?: OptionalNumber;
    height?: OptionalNumber;
}
// Hook

export const useWindowSize = (): WindowSize => {
    // Initialize state with undefined width/height so server and client renders match
    // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
    const [windowSize, setWindowSize] = useState<WindowSize>({
        width: undefined,
        height: undefined,
    });

    useEffect((): Effect => {
        // Handler to call on window resize
        const handleResize = (): void =>
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });


        // Add event listener
        window.addEventListener("resize", handleResize);

        // Call handler right away so state gets updated with initial window size
        handleResize();

        // Remove event listener on cleanup
        return (): void => window.removeEventListener("resize", handleResize);
    }, []); // Empty array ensures that effect is only run on mount

    return windowSize;
}

// check window ration
export const isHorizontal = (w: OptionalNumber, h: OptionalNumber): boolean => (optionalNumber(w) > optionalNumber(h))
export const isVertical = (w: OptionalNumber, h: OptionalNumber): boolean => (optionalNumber(h) > optionalNumber(w))

export const whRatio = (w: OptionalNumber, h: OptionalNumber): number => (optionalNumber(w) / optionalNumber(h))
export const hwRatio = (w: OptionalNumber, h: OptionalNumber): number => (optionalNumber(h) / optionalNumber(w))